import {
	Suspense,
	lazy
} from "react";
import {
	createBrowserRouter,
} from "react-router-dom";
import Loading from "../components/loading";
import Landing from "../screens/main/landing";
import Book from "../screens/main/book";
import Legal from "../screens/main/legal";
import Review from "../screens/main/review";
import Restaurants from "../screens/main/restaurants";
import TimeSlots from "../screens/admin/time-slots";
import Agenda from "../screens/main/agenda";
import Users from "../screens/admin/users";
import CheckRoute from "../components/check-route";
import Reviews from "../screens/admin/reviews";
import Reservations from "../screens/admin/reservations";
import PricesTypes from "../screens/admin/prices-types";
const QRPage = lazy(() => import("../screens/admin/qr-code"));
const Categories = lazy(() => import("../screens/admin/categories"));
const SubCategories = lazy(() => import("../screens/admin/subcategories"));
const Products = lazy(() => import("../screens/admin/products"));
const Labels = lazy(() => import("../screens/admin/labels"));
const Carta = lazy(() => import("../screens/main/carta"));
const Menus = lazy(() => import("../screens/admin/menus"));
const Restaurant = lazy(() => import("../screens/admin/restaurants"));
const Home = lazy(() => import("../screens/main/home"));
const MenuGroup = lazy(() => import("../screens/main/menu-group"));
const AppAdmin = lazy(() => import('../app-admin'));
const App = lazy(() => import('../app'));

export const globalRoutes = [
	{
		path: "admin",
		element: <AppAdmin />,
		children: [
			{
				path: "restaurants",
				meta: { title: "" },
				element: (
					<Suspense fallback={<Loading />}>
						<Restaurant />
					</Suspense>
				)
			},
			{
				path: "categories",
				meta: { title: "Families" },
				element: (
					<Suspense fallback={<Loading />}>
						<Categories />
					</Suspense>
				)
			},
			{
				path: "subcategories",
				meta: { title: "Categories" },
				element: (
					<Suspense fallback={<Loading />}>
						<SubCategories />
					</Suspense>
				)
			},
			{
				path: "products",
				meta: { title: "Productes" },
				element: (
					<Suspense fallback={<Loading />}>
						<Products />
					</Suspense>
				)
			},
			{
				path: "labels",
				meta: { title: "Etiquetes" },
				element: (
					<Suspense fallback={<Loading />}>
						<Labels />
					</Suspense>
				)
			},
			{
				path: "menu",
				meta: { title: "Menús" },
				element: (
					<Suspense fallback={<Loading />}>
						<Menus />
					</Suspense>
				)
			},
			{
				path: "qr",
				meta: { title: "Codis QR" },
				element: (
					<Suspense fallback={<Loading />}>
						<QRPage />
					</Suspense>
				)
			},
			{
				path: "time-slots",
				meta: { title: "Franges Horaries" },
				element: (
					<Suspense fallback={<Loading />}>
						<TimeSlots />
					</Suspense>
				)
			},
			{
				path: "users",
				meta: { title: "Franges Horaries" },
				element: (
					<Suspense fallback={<Loading />}>
						<Users />
					</Suspense>
				)
			},
			{
				path: "reviews",
				meta: { title: "Valoracions" },
				element: (
					<Suspense fallback={<Loading />}>
						<Reviews />
					</Suspense>
				)
			},
			{
				path: "reservations",
				meta: { title: "Reserves" },
				element: (
					<Suspense fallback={<Loading />}>
						<Reservations />
					</Suspense>
				)
			},
			{
				path: "prices",
				meta: { title: "Tipus de preus" },
				element: (
					<Suspense fallback={<Loading />}>
						<PricesTypes />
					</Suspense>
				)
			}
        ]
    },
	{
		path: '/',
		element: <App />,
		children: [
			{
				path: "",
				meta: { title: "" },
				element: (
					<Suspense fallback={<Loading />}>
						<Restaurants />
					</Suspense>
				)
			},
			{
				path: "landing",
				meta: { title: "" },
				element: (
					<Suspense fallback={<Loading />}>
						<CheckRoute>
							<Landing />
						</CheckRoute>
					</Suspense>
				)
			},
			{
				path: "agenda",
				meta: { title: "" },
				element: (
					<Suspense fallback={<Loading />}>
						<CheckRoute>
							<Agenda />
						</CheckRoute>
					</Suspense>
				)
			},
			{
				path: "book",
				meta: { title: "" },
				element: (
					<Suspense fallback={<Loading />}>
						<Book />
					</Suspense>
				)
			},
			{
				path: "review",
				meta: { title: "" },
				element: (
					<Suspense fallback={<Loading />}>
						<CheckRoute>
							<Review />
						</CheckRoute>
					</Suspense>
				)
			},
			{
				path: "legal",
				meta: { title: "" },
				element: (
					<Suspense fallback={<Loading />}>
						<Legal />
					</Suspense>
				)
			},
			{
				path: "home",
				meta: { title: "" },
				element: (
					<Suspense fallback={<Loading />}>
						<CheckRoute>
							<Home />
						</CheckRoute>
					</Suspense>
				)
			},
			{
				path: "carta",
				meta: { title: "" },
				element: (
					<Suspense fallback={<Loading />}>
						<Carta />
					</Suspense>
				)
			},
			{
				path: "menu-group",
				meta: { title: "Menú" },
				element: (
					<Suspense fallback={<Loading />}>
						<CheckRoute>
							<MenuGroup />
						</CheckRoute>
					</Suspense>
				)
			}
		]
	}
			
];

const router = createBrowserRouter(globalRoutes);

export default router;